import styled from "styled-components";
import { Flex } from "@evergis/ui";

import { Description } from "../../components/styled/forms";
import { stylesFor } from "../../styles/queries";

export const Desc = styled(Description)`
  color: black;

  &:last-of-type {
    margin-bottom: 2rem;
  }

  ${stylesFor.laptop} {
    margin-bottom: 1rem;

    &:last-of-type {
      margin-bottom: 1rem;
    }
  }
`;

export const CheckboxesContainer = styled(Flex)`
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;

  > label > span {
    overflow: visible;
  }

  ${Desc} {
    text-align: left;
  }

  ${Description} {
    margin-bottom: 0;
  }

  svg {
    overflow: hidden;
    border-radius: ${({ theme: { borderRadius } }) => borderRadius.xSmall};
  }
`;
